<template>
   <textarea  v-model="etxt" onclick="this.select()"></textarea>
   <form method="POST"  target="_blank" :action="actionUrl">
   <input v-model="jsonEtxt" onclick="this.select()" name="data_arr"><input type="submit" value="GO">
   </form>
</template>


<script>

import { TableTls } from "../app/tools/TableTls"
export default {
name:'excelTextView',
props:['arrayOfObjects','colArray','actionUrl'],
data(){
    return{
       etxt:"",
    }
},
mounted() {
    this.etxt = TableTls.json2EtxtByObj(this.arrayOfObjects,this.colArray);
  },
    methods: {
      das(){
         this.etxt = TableTls.json2EtxtByObj(this.arrayOfObjects,this.colArray);
      }
   
  
  },
  computed: {
  jsonEtxt(){
   
    return JSON.stringify( TableTls.etxt2jsonByObj(this.etxt,this.colArray));
  }

  },
  watch: {
   arrayOfObjects:function(){
     this.das();
   },
   colArray:function(){
     this.das();
   }
  },
}
</script>

<style>

</style>